// For browsers that don't support normalization (IE<=11), ignore it
export default function comparable(value) {
  return (String(value).normalize?.('NFD') ?? String(value))
    .toLowerCase()
    .replaceAll(/\s+/g, ' ')
    .replaceAll(/[^ 0-9a-z]/g, '')
    .trim();
}
